/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import type ItemList from 'flarum/common/utils/ItemList';
import type Mithril from 'mithril';

/**
 * `UserCard` is typed with the bare `ComponentAttrs`, which resolves to an empty
 * shape outside of core's own compilation scope. Only `className` is read here.
 */
export interface UserCardAttrs {
	className?: string;
}

export default function () {
	extend(UserCard.prototype, 'infoItems', function (this: UserCard, items: ItemList<Mithril.Children>) {
		const attrs = this.attrs as UserCardAttrs;

		if (attrs.className && attrs.className.includes('UserHero')) {
			items.add('hero-title', <h2>{app.translator.trans('glowingblue-orell-thalia-common.forum.user.title')}</h2>);
		}
	});
}
